import { call, put, takeLatest, all } from 'redux-saga/effects';
import { fetchClient } from '../utilities/fetchClient';
import ActionTypes from '../actions/actionTypes';
import {
  fetchNotificationsSuccess,
  fetchNotificationsFailure,
  markNotificationsReadSuccess,
  markNotificationsReadFailure,
} from '../actions/notificationActions';
import Env from '../Env';

function* getNotifications() {
  try {
    const header = {
      'Ocp-Apim-Subscription-Key': Env.getApimKey(),
    };
    const notifications = yield call(fetchClient, {
      url: 'notifications-api/v1/notifications',
      headers: header,
      apiServer: Env.getApimBaseUrl()
    });
    yield put(fetchNotificationsSuccess(notifications));
  } catch (e) {
    yield put(fetchNotificationsFailure());
  }
}

function* markNotificationsRead(action) {
  const { notificationId, updateNotificationRequest } = action.payload;

  try {
    const header = {
      'Ocp-Apim-Subscription-Key': Env.getApimKey(),
    };

    yield call(fetchClient, {
      url: `notifications-api/v1/notifications/${notificationId}`,
      method: 'PATCH',
      body: updateNotificationRequest,
      headers: header,
      apiServer: Env.getApimBaseUrl()
    });
    yield put(markNotificationsReadSuccess(notificationId));
  } catch (e) {
    yield put(markNotificationsReadFailure());
  }
}

export default function* notificationsSaga() {
  yield all([
    takeLatest(ActionTypes.NOTIFICATIONS.FETCH.REQUEST, getNotifications),
    takeLatest(ActionTypes.NOTIFICATIONS.MARK_AS_READ.REQUEST, markNotificationsRead)
  ]);
}
